import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as compass from '../ui/compass.js';

export {
    init,
}

let voix;

const POIs = [
    {
        name: 'telephone',
        position: { x: -7, y: 10, z: 0 },
        color: 'white',
        sound: {
            name: 'telephone',
            gain: 0,
        },
        collision: {
            radius: 1,
        },
        async onEnter() {
            this.sound.source.fadeTo(0, -90, 0);
            
            voix = await audio.buffers.play('voix', {
                destination: this.sound.panner,
                gain: 0,
            });
        },
        onLeave() {
            this.sound.source.fadeTo(1, 0, -90);
            voix?.fade(1, -90, true);
        },
        onStart() {
            audio.panner.play(this);
        },
    },
];

const sounds = [
    { name: 'telephone', url: new URL('../../sound/telephone.wav', import.meta.url) },
    { name: 'voix', url: new URL('../../sound/VoixTelephone.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
